import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import BeatLogo from 'assets/img/landing/applicationLogoWhite.svg';
import {
  UilInstagram,
  UilLinkedin,
  UilTwitter
} from '@iconscout/react-unicons';
// import { useNavigate } from 'react-router-dom';

const icons = [
  {
    component: UilLinkedin,
    id: 'linkedin',
    route: 'https://www.linkedin.com/company/crudbeat/'
  },
  {
    component: UilInstagram,
    id: 'instagram',
    route: 'https://www.linkedin.com/company/crudbeat/'
  },
  {
    component: UilTwitter,
    id: 'twitter',
    route: 'https://www.linkedin.com/company/crudbeat/'
  }
];
const content = [
  'Copyright 2024 Crud Beat',
  'Design By Crud Operations',
  'Support Policy',
  'Terms & Conditions',
  'Privacy Policy'
];
// const contactLinks = [
//   { label: 'About Us', link: '/about' },
//   { label: 'Contact Us', link: '/contact' },
//   { label: 'Privacy Policy', link: '' },
//   { label: 'Terms of Service', link: '' }
// ];
const Footer = () => {
  // const navigate = useNavigate();
  return (
    <Container className="landing_footer" fluid>
      <Row className="d-flex justify-content-between align-items-center ps-lg-14">
        <Col className="text-white pe-lg-14 pt-6" lg={5}>
          <div className="d-flex flex-column gap-4">
            <Image src={BeatLogo} width={70} fluid />
            <div className="fs-8 landing_footer_details">
              Crud Beat connects students, recruiters, and colleges, fostering
              career opportunities and professional growth in a supportive
              community. Stay updated!
            </div>
            <div className="d-flex gap-4 flex-wrap align-items-end">
              {icons.map(icon => (
                <div
                  key={icon.id}
                  className="landing_footer_icon p-2 rounded-circle"
                >
                  <a href={icon.route} target="_blank" rel="noreferrer">
                    <icon.component />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </Col>
        {/* <Col className="text-white ps-lg-5 pt-6" lg={7}>
          <Row>
            <Col lg={12} className="d-flex justify-content-lg-around">
              <div className="d-flex flex-column gap-4">
                <div>
                  <div className="fw-bolder">Company</div>
                </div>
                <div className="d-flex flex-column gap-2 landing_footer_sub">
                  {contactLinks.map((doc, idx) => (
                    <div
                      className="cursor-pointer"
                      key={idx}
                      onClick={() => doc.link && navigate(doc.link)}
                    >
                      {doc.label}
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Col> */}
      </Row>
      <div className="pt-14 pb-3 d-flex gap-6 justify-content-center flex-wrap">
        {content.map((info, idx) => (
          <div key={idx} className="landing_footer_details fs-9 text-center">
            {info}
          </div>
        ))}
      </div>
    </Container>
  );
};

export default Footer;
